function AssetCloneIcon() {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='28' height='28' viewBox='0 0 28 28' fill='none'>
      <rect width='28' height='28' rx='4' fill='#ECE9F2' />
      <g clipPath='url(#clip0_29551_71880)'>
        <path
          d='M15.9997 6.66797H8.66634C7.93301 6.66797 7.33301 7.26797 7.33301 8.0013V16.668C7.33301 17.0346 7.63301 17.3346 7.99967 17.3346C8.36634 17.3346 8.66634 17.0346 8.66634 16.668V8.66797C8.66634 8.3013 8.96634 8.0013 9.33301 8.0013H15.9997C16.3663 8.0013 16.6663 7.7013 16.6663 7.33464C16.6663 6.96797 16.3663 6.66797 15.9997 6.66797ZM18.6663 9.33464H11.333C10.5997 9.33464 9.99967 9.93464 9.99967 10.668V20.0013C9.99967 20.7346 10.5997 21.3346 11.333 21.3346H18.6663C19.3997 21.3346 19.9997 20.7346 19.9997 20.0013V10.668C19.9997 9.93464 19.3997 9.33464 18.6663 9.33464ZM17.9997 20.0013H11.9997C11.633 20.0013 11.333 19.7013 11.333 19.3346V11.3346C11.333 10.968 11.633 10.668 11.9997 10.668H17.9997C18.3663 10.668 18.6663 10.968 18.6663 11.3346V19.3346C18.6663 19.7013 18.3663 20.0013 17.9997 20.0013Z'
          fill='#402080'
        />
      </g>
      <defs>
        <clipPath id='clip0_29551_71880'>
          <rect width='16' height='16' fill='white' transform='translate(6 6)' />
        </clipPath>
      </defs>
    </svg>
  )
}

export default AssetCloneIcon
